import type { ColumnDef } from '@ics-portal/ics-data-table';
import type { GetComponentsSearchPagedQuery } from '@gql/graphql';

export type ComponentRow =
    GetComponentsSearchPagedQuery['components']['edges'][number]['node'];

export const COMPONENT_COLUMNS: ColumnDef<ComponentRow>[] = [
    {
        field: 'componentVendor.name',
        header: 'Vendor',
        filter: 'text',
        filterKey: 'hasComponentVendorWith.name',
        sortable: false,
    },
    {
        field: 'name',
        header: 'Name',
        filter: 'text',
        filterKey: 'name',
        sortKey: 'NAME',
    },
    {
        field: 'version',
        header: 'Version',
        filter: 'text',
        filterKey: 'version',
        sortKey: 'VERSION',
    },
    {
        field: 'id',
        header: 'ID',
        hidden: true,
        filter: 'text',
        filterKey: 'id',
        sortKey: 'ID',
    },
    {
        field: 'isValid',
        header: 'Valid',
        hidden: true,
        type: 'boolean',
        filterKey: 'isValid',
        sortKey: 'ISVALID',
    },
    {
        field: 'eolReached',
        header: 'EOL reached',
        hidden: true,
        type: 'boolean',
        filterKey: 'eolReached',
        sortKey: 'EOLREACHED',
    },
    {
        field: 'eolDate',
        header: 'EOL date',
        hidden: true,
        type: 'shortDate',
        filterKey: 'eolDate',
        sortKey: 'EOLDATE',
    },
    {
        field: 'cpeName',
        header: 'CPE name',
        hidden: true,
        filter: 'text',
        filterKey: 'cpeName',
        sortKey: 'CPENAME',
    },
    {
        field: 'monitoredSince',
        header: 'Monitored since',
        hidden: true,
        type: 'shortDate',
        filterKey: 'monitoredSince',
        sortKey: 'MONITOREDSINCE',
    },
    {
        field: 'url',
        header: 'URL',
        hidden: true,
        filter: 'text',
        filterKey: 'url',
        sortKey: 'URL',
    },
    {
        field: 'securityUrl',
        header: 'Security URL',
        hidden: true,
        filter: 'text',
        filterKey: 'securityURL',
        sortKey: 'SECURITYURL',
    },
    {
        field: 'createTime',
        header: 'Created',
        hidden: true,
        type: 'dateTime',
        filterKey: 'createTime',
        sortKey: 'CREATETIME',
    },
    {
        field: 'updateTime',
        header: 'Updated',
        hidden: true,
        type: 'dateTime',
        filterKey: 'updateTime',
        sortKey: 'UPDATETIME',
    },
    {
        field: 'componentVendor.ifa',
        header: 'Vendor IFA',
        hidden: true,
        filter: 'text',
        filterKey: 'hasComponentVendorWith.ifa',
        sortable: false,
    },
    {
        field: 'componentVendor.description',
        header: 'Vendor description',
        hidden: true,
        filter: 'text',
        filterKey: 'hasComponentVendorWith.description',
        sortable: false,
    },
];
